export default __webpack_public_path__ + "static/media/bob-mastery-test-win.7555de96.png";